/* global JSX */
import { Box } from "@mui/material";
import * as React from "react";
import { IFileAttachment } from "ui/Scripts/source/models/common/fileAttachment";
import { ListLinkValue } from "../../framework/List/ListLinkValue";
import { ListStateIconAttachment } from "../../framework/List/ListStateIconAttachment";
import { Translations } from "ui/Scripts/source/models/translations";
import { EventUserState } from "ui/Scripts/source/models/enums";

export interface IRecordEditListFirstColProp {
    id: string;
    code: string;
    userState?: EventUserState;
    attachments: IFileAttachment[];
    onClick: (id: string) => void;
    suffixElement?: JSX.Element;
    paddingLeft?: string | number;
}

export class RecordEditListFirstCol extends React.Component<IRecordEditListFirstColProp, {}> {
    hasAttachment = (id: string): boolean => {
        return !!this.props.attachments.find(i => i.subOwnerId === id);
    };

    render() {
        const props = this.props;
        return (
            <Box
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    flexGrow: 2,
                    paddingLeft: props.paddingLeft || undefined,
                }}
            >
                <ListLinkValue onClick={() => props.onClick(props.id)}>{props.code}</ListLinkValue>
                <Box display="flex">
                    {props.suffixElement}
                    {props.userState === EventUserState.NotApproved &&
                        <span className="icon approved red" title={Translations.FamiliarizationIsNotApprovedByUser}></span>
                    }
                    {props.userState === EventUserState.Approved &&
                        <span className="icon approved" title={Translations.FamiliarizationIsApprovedByUser}></span>
                    }
                    {this.hasAttachment(props.id) &&
                        <ListStateIconAttachment hasAttachments />
                    }
                </Box>
            </Box>
        );
    }
}